import OrderList from './OrderList'
import RechargeList from './RechargeList'

export default {
  OrderList,
  RechargeList,
}
